import { type ChangeEvent, type ClipboardEvent, type FC, type InputHTMLAttributes, useCallback } from "react";

import { styles } from "../../../helpers";
import "./style.scss";

interface TextBoxProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    inline?: boolean;
    changeHandler?: (value: any, name?: any) => void;
    pasteHandler?: (value: string, name?: any) => string;
    outerClassName?: string;
}

export const TextBox: FC<TextBoxProps> = (props) => {
    const { label, inline, changeHandler, className, pasteHandler, outerClassName, onChange, onPaste, id, ...rest } = props;

    const handleChange = useCallback(
        (e: ChangeEvent<HTMLInputElement>) => {
            if (changeHandler) {
                changeHandler(e.target.value, id);
            } else if (onChange) {
                onChange(e);
            }
        },
        [changeHandler, onChange, id],
    );

    const handlePaste = useCallback(
        (e: ClipboardEvent<HTMLInputElement>) => {
            if (pasteHandler) {
                e.preventDefault();
                const pastedText = e.clipboardData.getData("text/plain");
                const modifiedText = pasteHandler(pastedText, id);
                window.document.execCommand("insertText", false, modifiedText);
            } else if (onPaste) {
                onPaste(e);
            }
        },
        [pasteHandler, onPaste, id],
    );

    return (
        <div className={styles(outerClassName)}>
            <div className={styles(inline && label && "flex items-center")}>
                <label htmlFor={id} className="label">
                    {label} {rest.required && "*"}
                </label>
                <div className={inline ? "ml-2" : "mt-2"}>
                    <input id={id} {...rest} className={styles("input", className)} onChange={handleChange} onPaste={handlePaste} />
                </div>
            </div>
        </div>
    );
};
